import React from "react";
import {findDOMNode} from "react-dom";
import Classes from "classnames";
import Popover from "../../../../../gd-components/gd-popover/popover";

export default function FieldColor_Popover(props:any) {

    const hidePopover = () => props.parent.hidePopover()

    return (
        <Popover attachment="top center"
                 targetAttachment="bottom center"
                 getTargetFunc={()=>findDOMNode(props.parent)}
                 onClickOutside={()=>{props.parent.hidePopover()}}>

            <div className="ui5-popover-selector color-picker">
                <div className="ui5-title-tiny">Select color</div>

                {props.field.getOptions().map((option:any)=>
                    <div key={option.value}
                         className={Classes("ui5-color-picker", props.field.colorPalette+option.value)}
                         onClick={props.parent.onOptionClick.bind(null, option)}
                         // onClick={props.parent.onOptionClick.bind(this, option)}
                    />
                )}

                {/*{props.field.noColorAllowed && <div className="ui5-color-picker empty" onClick={props.parent.onOptionClick.bind(this, null)}/>}*/}
                {props.field.noColorAllowed && <div className="ui5-color-picker empty" onClick={props.parent.onOptionClick.bind(null, null)}/>}

                <div className="cf"></div>
            </div>

        </Popover>
    );



}
